var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.7,
    height: 19.205,
    viewBox: "0 0 16.7 19.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_2851559_city_delivery_gps_location_map_icon",
    "data-name": "2851559_city_delivery_gps_location_map_icon",
    transform: "translate(-15.693 -11.495)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18493",
    "data-name": "Path 18493",
    d: "M29.973,34.586H31a.9.9,0,0,1,.9.9v9.673a.9.9,0,0,1-.9.9H17.088a.9.9,0,0,1-.9-.9V35.481a.9.9,0,0,1,.9-.9h5.566",
    transform: "translate(0 -15.85)",
    fill: "none",
    stroke: "#929292",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18494",
    "data-name": "Path 18494",
    d: "M25.006,52.725",
    transform: "translate(-6.183 -28.576)",
    fill: "none",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18495",
    "data-name": "Path 18495",
    d: "M25.006,42.636",
    transform: "translate(-6.183 -21.498)",
    fill: "none",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18496",
    "data-name": "Path 18496",
    d: "M40.312,55.916V49.795l1.466-1.128",
    transform: "translate(-16.922 -25.729)",
    fill: "none",
    stroke: "#929292",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x1: 3.631,
    transform: "translate(19.733 27.105)",
    fill: "none",
    stroke: "#929292",
    strokeLinecap: "round",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x1: 2.277,
    y1: 0.003,
    transform: "translate(26.736 25.043)",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 5.878,
    y1: 0.003,
    transform: "translate(16.215 21.466)",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    y1: 11.453,
    transform: "translate(19.694 18.748)",
    fill: "none",
    stroke: "#929292",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18497",
    "data-name": "Path 18497",
    d: "M59.2,54.562V46.808h2.855",
    transform: "translate(-30.172 -24.425)",
    fill: "none",
    stroke: "#929292",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18498",
    "data-name": "Path 18498",
    d: "M45.714,15.3c0,1.828-3.31,7.4-3.31,7.4S39.1,17.132,39.1,15.3a3.309,3.309,0,0,1,6.619,0Z",
    transform: "translate(-16.068)",
    fill: "none",
    stroke: "#929292",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_471",
    "data-name": "Ellipse 471",
    cx: 1.413,
    cy: 1.413,
    r: 1.413,
    transform: "translate(24.923 13.891)",
    fill: "none",
    stroke: "#929292",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.492bd79a7fbef1a105ac23fd5ff6cfaf.svg";
export { ForwardRef as ReactComponent };